import CompanyNameHeader from '../Shared/CompanyName/CompanyName';
import MarketApproach from './Assets/MarketApproach';
import AssetBasedApproach from './Assets/AssetApproach';
import IncomeApproach from './Assets/IncomeApproach';
import FinalValuationEstimate from './Assets/FinalValuationEstimate';

const ValuationAnalysis = () => (
  <>
    {/* 0. company name */} 
    <CompanyNameHeader />

    {/* 1. Market Approach */}
    <MarketApproach />

    {/* 1. Market Approach */}
    <AssetBasedApproach />
    
    {/* 1. Market Approach */}
    <IncomeApproach />

    {/* 1. Market Approach */}
    <FinalValuationEstimate />
  
      
  </>
);

export default ValuationAnalysis;
